<template>
  <div>
      <DelinquentTaxBrowse />
  </div>
</template>

<script>
import DelinquentTaxBrowse from '../../../../components/tax/delinquent/browse/DelinquentTaxBrowse.vue';

export default {
  name: 'delinquentTaxBrowse',
  components: {
    DelinquentTaxBrowse,
  },
};

</script>
